(function() { window.GUID_f3e66415_6f45_439d_813d_9c0db4d19e3e = { getGuid: function() { return "f3e66415-6f45-439d-813d-9c0db4d19e3e"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NewsfeedFilter;
        (function (NewsfeedFilter) {
            NewsfeedFilter[NewsfeedFilter["All"] = 0] = "All";
            NewsfeedFilter[NewsfeedFilter["FromMe"] = 1] = "FromMe";
            NewsfeedFilter[NewsfeedFilter["ToMe"] = 2] = "ToMe";
        })(NewsfeedFilter = Enumeration.NewsfeedFilter || (Enumeration.NewsfeedFilter = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NewsfeedFilter.pre.js.map
